module.exports = __webpack_public_path__ + "img/incognito.474cfcd6.svg";